module.exports = __webpack_public_path__ + "img/08.c98e37b7.jpg";